import { Progress, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { checkSellerProgressPercentage } from "../../../../../utils/checkSellerProgressPercentage";
import Main from "../../../../layout/main/Main";
import { COLORS, Typo } from "../../../../layout/theme";
import {
	Container,
	GraphContainer,
	Inner,
	Section,
	StyledLi,
	StyledOl,
} from "./styles";

const { Title, Paragraph } = Typography;

export default function SellerStartGuide({ userdata }) {
	const [percent, setPercent] = useState(0);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		setPercent(() => checkSellerProgressPercentage(userdata));
	}, [userdata]);

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>Guia de Inicio</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
				<Main.Title>
					<Title style={{ color: COLORS.Primary, marginTop: 30 }} level={3}>
						Te damos la bienvenida a One Transfer
					</Title>
				</Main.Title>
				<Main.SubTitle>
					<Paragraph>
						<blockquote>
							En esta sección te dejamos una guía de pasos para que puedas
							configurar tu cuenta y disfrutar tu estadía en nuestro sitio
						</blockquote>
					</Paragraph>
				</Main.SubTitle>
			</Main.Header>

			<Inner>
				<Section>
					<Container>
						<Typo type="primary" level={4}>
							Pasos
						</Typo>
						<StyledOl>
							<StyledLi>
								<Link to="/admin/account">
									Configurá tu cuenta y seleccioná las Droguerías{" "}
									{userdata?.guideProgress > 0 &&
										userdata?.guideProgress < 9 && (
											<BsFillCheckCircleFill
												color={COLORS.Success}
												style={{ marginLeft: 10 }}
											/>
										)}
								</Link>
							</StyledLi>
							<StyledLi>
								{userdata?.guideProgress > 0 && userdata?.guideProgress < 9 ? (
									<Link to="/admin/items">
										Cargá y editá tus Productos y Marcas{" "}
										{userdata?.guideProgress > 1 &&
											userdata?.guideProgress < 9 && (
												<BsFillCheckCircleFill
													color={COLORS.Success}
													style={{ marginLeft: 10 }}
												/>
											)}
									</Link>
								) : (
									"Cargá y editá tus Productos y Marcas"
								)}
							</StyledLi>
							<StyledLi>
								{userdata?.guideProgress > 1 && userdata?.guideProgress < 9 ? (
									<Link to="/admin/prices">
										Chequeá y editá Precios de forma masiva{" "}
										{userdata?.guideProgress > 2 &&
											userdata?.guideProgress < 9 && (
												<BsFillCheckCircleFill
													color={COLORS.Success}
													style={{ marginLeft: 10 }}
												/>
											)}
									</Link>
								) : (
									"Chequeá y editá Precios de forma masiva"
								)}
							</StyledLi>
							<StyledLi>
								{userdata?.guideProgress > 2 && userdata?.guideProgress < 9 ? (
									<Link to="/admin/users">
										Podés visualizar los usuarios que acceden el sitio{" "}
										{userdata?.guideProgress > 3 &&
											userdata?.guideProgress < 9 && (
												<BsFillCheckCircleFill
													color={COLORS.Success}
													style={{ marginLeft: 10 }}
												/>
											)}
									</Link>
								) : (
									"Podés visualizar los usuarios que acceden el sitio"
								)}
							</StyledLi>
							<StyledLi>
								{userdata?.guideProgress > 3 && userdata?.guideProgress < 9 ? (
									<Link to="/admin/ventas">
										Podés ver un listado de todas tus ventas{" "}
										{userdata?.guideProgress > 4 &&
											userdata?.guideProgress < 9 && (
												<BsFillCheckCircleFill
													color={COLORS.Success}
													style={{ marginLeft: 10 }}
												/>
											)}
									</Link>
								) : (
									"Podés ver un listado de todas tus ventas"
								)}
							</StyledLi>
							<StyledLi>
								{userdata?.guideProgress > 4 && userdata?.guideProgress < 9 ? (
									<Link to="/admin/dashboard">
										Podés tener un seguimiento del flujo general de tu empresa{" "}
										{userdata?.guideProgress > 5 &&
											userdata?.guideProgress < 9 && (
												<BsFillCheckCircleFill
													color={COLORS.Success}
													style={{ marginLeft: 10 }}
												/>
											)}
									</Link>
								) : (
									"Podés tener un seguimiento del flujo general de tu empresa"
								)}
							</StyledLi>
							<StyledLi>
								{userdata?.guideProgress > 5 && userdata?.guideProgress < 9 ? (
									<Link to="/admin/marketing">
										Podés cargar las publicidades que tengas activas{" "}
										{userdata?.guideProgress > 6 &&
											userdata?.guideProgress < 9 && (
												<BsFillCheckCircleFill
													color={COLORS.Success}
													style={{ marginLeft: 10 }}
												/>
											)}
									</Link>
								) : (
									"Podés cargar las publicidades que tengas activas"
								)}
							</StyledLi>
							<StyledLi>
								{userdata?.guideProgress > 6 && userdata?.guideProgress < 9 ? (
									<Link to="/admin/store">
										Configurá tu Tienda{" "}
										{userdata?.guideProgress > 7 &&
											userdata?.guideProgress < 9 && (
												<BsFillCheckCircleFill
													color={COLORS.Success}
													style={{ marginLeft: 10 }}
												/>
											)}
									</Link>
								) : (
									"Configurá tu Tienda"
								)}
							</StyledLi>
						</StyledOl>
					</Container>
					<GraphContainer>
						<Progress
							type="circle"
							percent={percent}
							style={{
								marginRight: 8,
							}}
						/>
					</GraphContainer>
				</Section>
			</Inner>
		</Main>
	);
}
